/**
 * Anthropic Claude API keys patterns:
 * - sk-ant-api03-... (original format) - 13 chars prefix
 * - sk-ant-api04-... (newer format) - 13 chars prefix
 *
 * Examples:
 * `sk-ant-api03-z0zjHHXo5uibD2havvfqiZYJe9ENlwI1trcQC5pyDC2N2w6nbpUitUU_iR4kkSszVyUpINaxvCtun3_Mub0O3w-48GXRgAA` (108 chars total)
 *
 * Breakdown: prefix(13) + middle(93) + suffix(2) = 108 chars
 * Pattern: sk-ant-api0[3-4]- + base64-like characters (exactly 93 chars) + ending with AA
 *
 * https://docs.anthropic.com/en/api/overview
 * https://docs.anthropic.com/en/api/admin-api/apikeys/get-api-key
 * https://docs.gitguardian.com/secrets-detection/secrets-detection-engine/detectors/specifics/claude_api_key
 */

export const anthropicApiKey = /sk-ant-api0\d-[A-Za-z0-9_-]{90,128}AA/;
